import { IonIcon } from '@ionic/react'
import { checkmarkCircle, closeCircle } from 'ionicons/icons'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Driver } from '~/shared/api/driver'
import { Button } from '~/shared/ui/Buttons'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { LogoContainer } from '~/shared/ui/LogoContainer'
import { myPalette } from '~/shared/ui/theme'

type State = 'loading' | 'success' | 'error'

export function EmailVerifyPage() {
  const [searchParams] = useSearchParams()
  const [state, setState] = useState<State>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')

    if (!token) {
      setState('error')
      setMessage('Токен подтверждения не найден')
      return
    }

    Driver.verifyEmailByToken(token)
      .then((res) => {
        setMessage(res.message)
        setState('success')
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ?? 'Не удалось подтвердить почту'
        setMessage(msg)
        setState('error')
      })
  }, [searchParams])

  return (
    <LogoContainer title='Подтверждение почты'>
      {state === 'loading' && <ProgressBlock height={200} />}

      {state === 'success' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: '24px 16px',
          }}
        >
          <IonIcon
            icon={checkmarkCircle}
            style={{
              color: myPalette.limeGreen.main,
              width: '64px',
              height: '64px',
            }}
          />
          <div
            style={{ fontSize: '18px', fontWeight: 600, textAlign: 'center' }}
          >
            Почта подтверждена
          </div>
          <div style={{ fontSize: '14px', color: '#666', textAlign: 'center' }}>
            {message}
          </div>
          <Button variant='limeFlooded' size='large' to='/'>
            Перейти в приложение
          </Button>
        </div>
      )}

      {state === 'error' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: '24px 16px',
          }}
        >
          <IonIcon
            icon={closeCircle}
            style={{
              color: myPalette.coral.main,
              width: '64px',
              height: '64px',
            }}
          />
          <div
            style={{ fontSize: '18px', fontWeight: 600, textAlign: 'center' }}
          >
            Не удалось подтвердить почту
          </div>
          <div style={{ fontSize: '14px', color: '#666', textAlign: 'center' }}>
            {message}
          </div>
          <Button variant='limeFlooded' size='large' to='/'>
            Перейти в приложение
          </Button>
        </div>
      )}
    </LogoContainer>
  )
}
